import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import AddressForm from "../../Assets/sc-client/Address/AddressForm";
import { CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import * as actions from '../store/profileActions';
import { hasPermission } from "../../sc-utilities";
import { CancelToken } from 'axios';
import { states, getStatesList, getCountryList } from '../../sc-utilities/CountriesAndUSstatesList';
import countries from 'i18n-iso-countries';

const AddressInformation = props => {
    const { activeCustomerID, loggedUser, translations, updateUserAddress, tabValue, permissions, onLoadAddress, userLanguage } = props;
    const [editData, setEditData] = useState({ data: false, loading: true });

    try {
        let lang = userLanguage;
        if (userLanguage.includes("zh-")) {
            lang = "zh";
        }
        countries.registerLocale(require(`i18n-iso-countries/langs/${lang}.json`));
    } catch (error) {
        console.log(error)
    }

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            let result = loggedUser.AddressID && await onLoadAddress({ ActiveCustomerID: activeCustomerID, AddressID: loggedUser.AddressID }, { listSource: requestToken })
            setEditData({ data: result?.data ?? {}, loading: false })
        }
        if (tabValue === 1 && !editData.data) {
            fetchData();
        }

        return () => {
            requestToken.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabValue]);

    const handleSubmit = async data => {
        let sendData = { ...data }
        sendData['Country'] = data?.Country?.key;
        if (data?.Country?.key === 'US' || data?.Country === 'US') {
            sendData['State'] = data?.State?.value;
        } else {
            sendData['State'] = null;
        }
        sendData["ActiveCustomerID"] = activeCustomerID;
        sendData["Type"] = 'user';
        sendData["UserID"] = loggedUser.UserID;
        if (editData?.data?.AddressID) {
            sendData["AddressID"] = editData.data.AddressID;
        }
        await updateUserAddress(sendData);
    }

    let countryName = (getCountryList(countries, userLanguage) ?? []).filter(el => el.key === editData?.data?.Country);
    let stateName = (getStatesList(states) ?? []).filter(el => el.value === editData?.data?.State);

    let initialValues = {
        City: editData?.data && editData?.data.City ? editData?.data.City : '',
        Country: countryName[0] || '',
        State: stateName[0] || '',
        AddressLine1: editData?.data?.AddressLine1 || '',
        AddressLine2: editData?.data?.AddressLine2 || '',
        GLN: editData?.data?.GLN || ''
    }

    let formSettings = {
        Validation: {
            City: Yup.string().required(),
            Country: Yup.string().required(),
            AddressLine1: Yup.string().required(),
            AddressLine2: Yup.string().required(),
            State: Yup.string().notRequired(),
            GLN: Yup.string().required()
        },
        ButtonSubmit: hasPermission(permissions, 'address_save') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return (
        !editData.loading ?
            <AddressForm
                countryList={getCountryList(countries, userLanguage)}
                usStatesList={getStatesList(states)}
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                profile={true}
                translations={translations}
                permissions={editData.permissions}
            /> :
            <CircularProgress />
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        loggedUser: state.core.login.user,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
        userLanguage: state?.core?.login?.userSettings?.DefaultLanguage,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateUserAddress: data => dispatch(actions.saveUserAddress(data)),
        onLoadAddress: (data, options) => dispatch(actions.loadAddress(data, options)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddressInformation);
